import React, { useState } from "react";
import ContentSvg from "../assets/images/svg/content-svg.svg";
import WmsTmsImg from "../assets/images/portfolio/wms-tms-platform.png";
import PharmacyEcommerceImg from "../assets/images/portfolio/pharmacy-ecommerce.png";
import WebhookIntegrationsImg from "../assets/images/portfolio/webhook-integrations.png";
import VideoConferenceImg from "../assets/images/portfolio/video-conference.png";
import InteractiveMapQuizImg from "../assets/images/portfolio/interactive-map-quiz.png";
import FleetAssetManagementImg from "../assets/images/portfolio/fleet-asset-management.png";
import PortAccidentDashboardImg from "../assets/images/portfolio/port-accident-dashboard.png";
import ReservationRsvpSystemImg from "../assets/images/portfolio/reservation-rsvp-system.png";
import FatigueSleepSystemImg from "../assets/images/portfolio/fatigue-sleep-system.png";
import PosApplicationImg from "../assets/images/portfolio/pos-application.png";
import InternalTodoAppImg from "../assets/images/portfolio/internal-todo-app.png";
import Popup from "./PopUp";

const Portfolio = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const [popupContent, setPopupContent] = useState(null);

  const PORTFOLIO_CONTENT = {
    wmsTms: {
      title: "WMS/TMS Platform",
      subtitle: "WZ TECHNOLOGY • TECH LEAD ENGINEER",
      createdBy: "WZ Technology",
      date: "March 2024 – Present",
      client: "Enterprise Logistics",
      categories: "WMS / TMS • Architecture • CI/CD",
      image: WmsTmsImg,
      image2: WmsTmsImg,
      description:
        "Spearheaded technical architecture and development for an enterprise-grade WMS/TMS, increasing system throughput by 35% to handle peak logistics demand. Designed and scaled robust architectures for high-volume traffic and complex logistics operations with maximum uptime and performance.",
      description2:
        "Led a team of 4 engineers with rigorous code reviews and engineering best practices, reducing production bugs by 20%. Defined technology stack and strategy (Laravel/Yii, Node.js/Express middleware), optimized databases, and enforced automated CI/CD for secure, zero-downtime releases.",
    },
    pharmacyEcommerce: {
      title: "Pharmacy E‑commerce",
      subtitle: "SPECTA CREATIVE • LARAVEL + TOKOPEDIA API",
      createdBy: "Specta Creative",
      date: "April 2019 – Present",
      client: "Pharmacy / Retail",
      categories: "E‑commerce • Integrations • REST API",
      image: PharmacyEcommerceImg,
      image2: PharmacyEcommerceImg,
      description:
        "Built a pharmacy e‑commerce platform using Laravel featuring Tokopedia API integration for real-time order tracking and a specialized doctor's prescription processing system.",
      description2:
        "Automated deployments by setting up CI/CD pipelines using GitHub Actions for reliable releases directly to a VPS environment.",
    },
    webhookIntegrations: {
      title: "Webhook Integrations",
      subtitle: "5,000+ DAILY TRANSACTIONS",
      createdBy: "WZ Technology",
      date: "February 2023 – March 2024",
      client: "Third‑party External Applications",
      categories: "Webhooks • Middleware • Integrations",
      image: WebhookIntegrationsImg,
      image2: WebhookIntegrationsImg,
      description:
        "Designed and deployed a dedicated webhook integration system (Laravel), reliably processing 5,000+ daily transactions. Engineered robust middleware services using Node.js (Express.js) and Laravel to connect the core WMS with multiple external applications.",
      description2:
        "Maintained and scaled the core WMS application using the Yii framework to optimize warehouse operations, and contributed to building a comprehensive TMS from the ground up using Laravel.",
    },
    videoConference: {
      title: "Video Conference App",
      subtitle: "ELISOFT TECHNOLOGY • JITSI INTEGRATION",
      createdBy: "Elisoft Technology",
      date: "December 2020 – December 2022",
      client: "Meeting / Collaboration",
      categories: "Real‑time • Video • Web App",
      image: VideoConferenceImg,
      image2: VideoConferenceImg,
      description:
        "Developed a real-time meeting and video conference application, integrating the Jitsi library to provide a seamless user experience.",
      description2:
        "Delivered stable meeting flows and integration patterns suitable for production use inside a larger web application ecosystem.",
    },
    interactiveMapQuiz: {
      title: "Interactive Map Quiz",
      subtitle: "SPECTA CREATIVE • AMCHARTS.JS",
      createdBy: "Specta Creative",
      date: "April 2019 – Present",
      client: "Web Experience",
      categories: "Interactive • Data Visualization",
      image: InteractiveMapQuizImg,
      image2: InteractiveMapQuizImg,
      description:
        "Engineered an engaging web-based interactive map quiz game utilizing amCharts.js for dynamic data visualization.",
      description2:
        "Focused on responsive interactions, smooth animations, and performance for a pleasant game-like UX.",
    },
    fleetAssetManagement: {
      title: "Fleet & Asset Management",
      subtitle: "ELISOFT TECHNOLOGY • LARAVEL + VUE.JS",
      createdBy: "Elisoft Technology",
      date: "December 2020 – December 2022",
      client: "Transportation Company",
      categories: "Fleet • Assets • Admin Panel",
      image: FleetAssetManagementImg,
      image2: FleetAssetManagementImg,
      description:
        "Engineered a monolithic web application for a transportation company to manage assets and fleets efficiently, utilizing Laravel and Vue.js.",
      description2:
        "Implemented operational workflows and maintainable backend + UI components to support day-to-day fleet and asset operations.",
    },
    portAccidentDashboard: {
      title: "Reporting Dashboard + REST API",
      subtitle: "SPECTA CREATIVE • LARAVEL",
      createdBy: "Specta Creative",
      date: "April 2019 – Present",
      client: "Port Operations",
      categories: "Dashboard • REST API • Mobile Integration",
      image: PortAccidentDashboardImg,
      image2: PortAccidentDashboardImg,
      description:
        "Developed a reporting dashboard and secure RESTful API with Laravel to manage port accident data integrated with a mobile application.",
      description2:
        "Focused on secure endpoints, structured reporting, and reliable data flow between web dashboard and mobile clients.",
    },
    reservationRsvp: {
      title: "Reservation & RSVP System",
      subtitle: "ELISOFT TECHNOLOGY • LARAVEL",
      createdBy: "Elisoft Technology",
      date: "December 2020 – December 2022",
      client: "Restaurant",
      categories: "Reservations • RSVP • Admin",
      image: ReservationRsvpSystemImg,
      image2: ReservationRsvpSystemImg,
      description:
        "Built a web-based reservation and RSVP management system for a restaurant from scratch using Laravel.",
      description2:
        "Implemented booking flows, guest management, and admin features needed for day-to-day operations.",
    },
    fatigueSleepSystem: {
      title: "Fatigue Sleep System",
      subtitle: "GOODEVA TECHNOLOGY • LARAVEL",
      createdBy: "Goodeva Technology",
      date: "September 2018 – December 2018",
      client: "Mobile Application",
      categories: "Backend • Reporting Dashboard • REST API",
      image: FatigueSleepSystemImg,
      image2: FatigueSleepSystemImg,
      description:
        "Built the backend and reporting dashboard for a Fatigue Sleep System using Laravel, including a secure RESTful API to support the mobile application.",
      description2:
        "Delivered core data flows and reporting views for operational monitoring and insights.",
    },
    posApplication: {
      title: "POS Application",
      subtitle: "GOODEVA TECHNOLOGY • LARAVEL",
      createdBy: "Goodeva Technology",
      date: "September 2018 – December 2018",
      client: "Business Operations",
      categories: "Sales • Transactions • Core Logic",
      image: PosApplicationImg,
      image2: PosApplicationImg,
      description:
        "Developed a web-based POS application with Laravel to streamline sales transactions and manage core business logic.",
      description2:
        "Implemented transaction workflows and operational screens for daily usage.",
    },
    internalTodo: {
      title: "Internal Todo App",
      subtitle: "GOODEVA TECHNOLOGY • LARAVEL",
      createdBy: "Goodeva Technology",
      date: "September 2018 – December 2018",
      client: "Internal Teams",
      categories: "Workflow • Tasks • Productivity",
      image: InternalTodoAppImg,
      image2: InternalTodoAppImg,
      description:
        "Created an internal Todo application from scratch using Laravel to improve daily workflow and task tracking for employees.",
      description2:
        "Focused on simple task management features to support consistent team execution.",
    },
  };

  const handlePopupOpen = (content) => (e) => {
    e?.preventDefault?.();
    setPopupContent(content);
    setIsPopupVisible(true);
  };

  const handlePopupClose = (e) => {
    e?.preventDefault?.();
    setIsPopupVisible(false);
  };

  return (
    <>
      {/* <!-- ====================================== Section Portfolio ===================================== --> */}
      <section className="portfolio-section" id="portfolio">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Portfolio.
          </h2>
          <div className="line"></div>
        </div>

        <div className="portfolios-group-main">
          <div>
            <div
              className="image-container popup-btn zoom_in"
              onClick={handlePopupOpen(PORTFOLIO_CONTENT.wmsTms)}
            >
              <img src={WmsTmsImg} alt="WMS/TMS Platform" />
              <div className="overlay">
                <img src={ContentSvg} alt="content" className="vimeo-icon" />
                <p className="overlay-text">WMS/TMS Platform</p>
              </div>
            </div>
            <p className="Corporate zoom_in">WMS/TMS Platform</p>
            <p className="Corporate-sub zoom_in">WZ Technology</p>

            <div className="second-row-portfolio youtube zoom_in">
              <div>
                <div
                  className="image-container"
                  onClick={handlePopupOpen(PORTFOLIO_CONTENT.pharmacyEcommerce)}
                >
                  <img src={PharmacyEcommerceImg} alt="Pharmacy E-commerce" />
                  <div className="overlay">
                    <img src={ContentSvg} alt="content" className="vimeo-icon" />
                    <p className="overlay-text">Pharmacy E‑commerce</p>
                  </div>
                </div>
              </div>
              <p className="Corporate">Pharmacy E‑commerce</p>
              <p className="Corporate-sub">Tokopedia API Integration</p>
            </div>

            <div className="second-row-portfolio zoom_in">
              <div>
                <div
                  className="image-container"
                  onClick={handlePopupOpen(PORTFOLIO_CONTENT.portAccidentDashboard)}
                >
                  <img
                    src={PortAccidentDashboardImg}
                    alt="Reporting Dashboard + REST API"
                  />
                  <div className="overlay">
                    <img
                      src={ContentSvg}
                      alt="content"
                      className="vimeo-icon"
                    />
                    <p className="overlay-text">Reporting Dashboard</p>
                  </div>
                </div>
              </div>
              <p className="Corporate">Reporting Dashboard + REST API</p>
              <p className="Corporate-sub">Port Accident Data</p>
            </div>

            <div
              className="second-row-portfolio popup-btn zoom_in"
              onClick={handlePopupOpen(PORTFOLIO_CONTENT.internalTodo)}
            >
              <div className="image-container">
                <img src={InternalTodoAppImg} alt="Internal Todo App" />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">Internal Todo App</p>
                </div>
              </div>
              <p className="Corporate">Internal Todo App</p>
              <p className="Corporate-sub">Workflow Tracking</p>
            </div>
          </div>

          <div>
            <div>
              <div
                className="image-container zoom_in"
                id="vimeo"
                onClick={handlePopupOpen(PORTFOLIO_CONTENT.webhookIntegrations)}
              >
                <img src={WebhookIntegrationsImg} alt="Webhook Integrations" />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">Webhook Integrations</p>
                </div>
              </div>
            </div>
            <p className="Corporate zoom_in">Webhook Integrations</p>
            <p className="Corporate-sub zoom_in">5,000+ Daily Transactions</p>

            <div>
              <div
                className="second-row-portfolio soundcloud zoom_in"
                onClick={handlePopupOpen(PORTFOLIO_CONTENT.videoConference)}
              >
                <div className="image-container">
                  <img src={VideoConferenceImg} alt="Video Conference App" />
                  <div className="overlay">
                    <img src={ContentSvg} alt="content" className="vimeo-icon" />
                    <p className="overlay-text">Video Conference App</p>
                  </div>
                </div>
                <p className="Corporate">Video Conference App</p>
                <p className="Corporate-sub">Jitsi Integration</p>
              </div>
            </div>

            <div>
              <div
                className="second-row-portfolio zoom_in"
                onClick={handlePopupOpen(PORTFOLIO_CONTENT.reservationRsvp)}
              >
                <div className="image-container">
                  <img
                    src={ReservationRsvpSystemImg}
                    alt="Reservation & RSVP System"
                  />
                  <div className="overlay">
                    <img src={ContentSvg} alt="content" className="vimeo-icon" />
                    <p className="overlay-text">Reservation & RSVP</p>
                  </div>
                </div>
                <p className="Corporate">Reservation & RSVP System</p>
                <p className="Corporate-sub">Restaurant Booking</p>
              </div>
            </div>

            <div
              className="second-row-portfolio popup-btn zoom_in"
              onClick={handlePopupOpen(PORTFOLIO_CONTENT.posApplication)}
            >
              <div className="image-container">
                <img src={PosApplicationImg} alt="POS Application" />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">POS Application</p>
                </div>
              </div>
              <p className="Corporate">POS Application</p>
              <p className="Corporate-sub">Sales Transactions</p>
            </div>
          </div>

          <div className="gallery-bank-section">
            <div className="zoom_in">
              <div
                className="image-container popup-btn"
                onClick={handlePopupOpen(PORTFOLIO_CONTENT.interactiveMapQuiz)}
              >
                <img src={InteractiveMapQuizImg} alt="Interactive Map Quiz" />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">Interactive Map Quiz</p>
                </div>
              </div>
              <p className="Corporate">Interactive Map Quiz</p>
              <p className="Corporate-sub">Data Visualization</p>
            </div>

            <div
              className="second-row-portfolio popup-btn zoom_in"
              onClick={handlePopupOpen(PORTFOLIO_CONTENT.fleetAssetManagement)}
            >
              <div className="image-container">
                <img
                  src={FleetAssetManagementImg}
                  alt="Fleet & Asset Management"
                />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">Fleet & Asset Management</p>
                </div>
              </div>
              <p className="Corporate">Fleet & Asset Management</p>
              <p className="Corporate-sub">Laravel + Vue.js</p>
            </div>

            <div
              className="second-row-portfolio popup-btn zoom_in"
              onClick={handlePopupOpen(PORTFOLIO_CONTENT.fatigueSleepSystem)}
            >
              <div className="image-container">
                <img src={FatigueSleepSystemImg} alt="Fatigue Sleep System" />
                <div className="overlay">
                  <img src={ContentSvg} alt="content" className="vimeo-icon" />
                  <p className="overlay-text">Fatigue Sleep System</p>
                </div>
              </div>
              <p className="Corporate">Fatigue Sleep System</p>
              <p className="Corporate-sub">Backend + Dashboard</p>
            </div>
          </div>
        </div>
      </section>

      <Popup
        isVisible={isPopupVisible}
        onClose={handlePopupClose}
        content={popupContent}
      />
    </>
  );
};

export default Portfolio;
